module.exports = __webpack_public_path__ + "img/av272.02ff0921.png";